import { render, staticRenderFns } from "./PrivayPolicy.vue?vue&type=template&id=7b96254c&"
import script from "./PrivayPolicy.vue?vue&type=script&lang=js&"
export * from "./PrivayPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports